<template>
  <div>
    <section>
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
			<div class="container">
				<ol class="breadcrumb hidden-xs">
						<li><a href="/">首頁</a></li>
						<li><a href="/product">購物商城</a></li>
						<li class="active">{{rowData.name}}</li>
				</ol>
				<div class="row">
					<div class="col-md-9 col-sm-12 col-xs-12 pull-right">
						<div class="row">
							<div class="col-sm-6 col-xs-12">
								<figure class="pic">
									<img :src="'https://files.i80.com.tw/images/product/'+rowData.imageL" class="img-responsive"/>
								</figure>
							</div>
							<div class="col-sm-6 col-xs-12">
								<h4 class="title">{{rowData.name}}</h4>
								<p>{{rowData.short}}</p>
								<ul class="list-unstyled product_intro">
									<li class="price_box">
										<span class="price">{{rowData.price}}</span>
										<p class="points"><span class="glyphicon glyphicon-gift"></span>
										    {{rowData.point}} 點
										</p>
									</li>
									<li><b class="title">付款方式</b>
										<ul class="list-unstyled list-inline payment">
											<li>信用卡</li>
											<li>ATM</li>
											<li>iBon</li>
										</ul>
									</li>
									<li>
										<b class="title">數量</b>
										<select  v-model="orderNumber" class="form-control amount">
												<option v-for="number in numbers" :value="number">{{ number }}</option>
										</select>
									</li>
								</ul>
								<button v-if="company.balance >=rowData.price && company.com_shopping=='Y'" type="button" class="btn btn-danger" @click="addToCart(rowData)">
									<span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> 加入購物車
								</button>
                <p v-if="company.com_shopping=='N'">
                  暫無開放線上購物，請聯絡店家進行購買 {{ company.com_phone }}
                </p>

                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
                  優惠方案
                </button>
								<br/><br/>
                分享到：
                <social-sharing :url="shareLink"
                :title="rowData.name"
                :description="rowData.name"
                hashtags="i80"
                inline-template>
                  <div>
                    <network network="facebook">
                      <i class="fab fa-facebook fa-2x"></i> Facebook
                    </network>
                    <network network="pinterest">
                      <i class="fab fa-fw fa-2x fa-pinterest"></i> Pinterest
                    </network>
                    <network network="line">
                      <i class="fab fa-line fa-2x"></i> Line
                    </network>
                  </div>
                </social-sharing>
              </div>
						</div>
						<hr>
						<h4 class="title">產品介紹</h4>
						<p  class="editor" v-html="rowData.content"></p>
            <div class="fb-like" :data-href="shareLink" data-share="true" data-width="120" data-show-faces="false"></div>
						<div class="fb-comments" :data-href="id" data-num-posts="2" data-width="100%"></div>
					</div>

					<div class="col-md-3 col-sm-12 col-xs-12">
						<h4 class="title">你可能會喜歡</h4>
						<div class="row">
							<div class="col-md-12 col-sm-4 col-xs-6" v-for="(item, index) in popular">
								<div class="product_box">
										<a v-bind:href="'/product/'+item.id">
											<figure class="pic">
												<img :src="'https://files.i80.com.tw/images/product/'+item.imageM" class="img-responsive">
											</figure>
										</a>
										<h5 class="title">{{item.name}}</h5>
										<p class="points">
											<span class="glyphicon glyphicon-gift" aria-hidden="true"></span>
											{{item.point}} 點
										</p>
										<p class="price">{{item.price}}</p>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</section>

    <!-- Modal -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">活動訊息</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              愛幫您的會員您好，只要按下分享愛幫您將贈送給您免費商品。<br/>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">關閉</button>
          </div>
        </div>
      </div>
    </div>

	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProductView',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      company: {},
      orderNumber: 1,
      id: '',
      shareLink: '',
      items: this.$store.getters.getCart,
      firstbuy: this.$store.getters.getFirstbuy,
      numbers: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
    // 尋找產品資料中是否有資料可取用
    let id = this.$route.params.id
    let shareid = this.$route.params.shareid
    if (shareid > 0) {
      this.$store.dispatch('SET_SHARE_ID', shareid)
      localStorage.setItem('shareid', shareid)
    } else {
      shareid = localStorage.getItem('userId')
    }
    this.id = id
    this.shareLink = 'https://www.i80.com.tw/product/' + id + '/' + shareid
    // 若沒有在產品資料中則直接從伺服器取得
    this.$http.get(this.apiurl + 'api/getProductID/' + id).then(function (res) {
      let row = res.body.data[0]
      this.rowData = row
      // 比對公司
      let companies = JSON.parse(localStorage.getItem('companies'))
      this.company = companies.find(function (item, index, array) {
        return item.m_factoryID === row.fid
      })
    }, function () {
      console.log('loading products is failed.')
    })
    // if (data.length < 1) {
    //   this.$http.get(this.apiurl + 'api/getProductID/' + id).then(function (res) {
    //     let row = res.body.data[0]
    //     this.rowData = row
    //     console.log(this.rowData)
    //     let companies = JSON.parse(localStorage.getItem('companies'))
    //     this.company = companies.find(function (item, index, array) {
    //       return item.m_factoryID === fid
    //     })
    //   }, function () {
    //     console.log('loading products is failed.')
    //   })
    // } else {
    //   this.rowData = data[0]
    // }
  },
  methods: {
    ...mapActions([
      'SET_PRODUCTS',
      'SET_SHARE_ID'
    ]),
    addToCart (row) {
      let cart = this.items
      if (cart.length > 0) {
        if (cart[0].fid !== row.fid) {
          window.alert('平台採單店結帳，請先進行結帳再購買其他店家商品謝謝')
          return false
        }
      }
      row.maximum = 20
      this.$store.dispatch('SAVE_ACTIVITY_ITEM', row.id)
      this.$store.dispatch('ADD_TO_CART', row)
    }
  },
  computed: {
    ...mapGetters({
      popular: 'getPopular'
    })
  },
  watch: {
    orderNumber: {
      handler: function (val, oldVal) {
        this.rowData.quantity = val
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductView.vue?a968d3b8